import Link from "next/link";
import React from "react";

const BlogCategories = ({ categories }) => (
  <div className="flex items-start w-full gap-2 overflow-x-auto sm:items-center flex-nowrap lg:w-auto">
    {categories.map((category) => (
      <Link
        key={category.id}
        href={category.url}
        prefetch={false}
        className="flex items-center flex-shrink-0 text-[#586474] justify-center border border-[#D9D9D9] rounded-full sm:py-3 py-2 sm:px-4 px-3 opacity-80 font-normal text-xs transition-all ease-in-out duration-200 hover:border-[#F06404] hover:text-[#F06404]"
      >
        {category.title}
      </Link>
    ))}
  </div>
);

export default BlogCategories;
